import script from "./PurchaseOrderForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseOrderForm.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseOrderForm.vue?vue&type=style&index=0&id=3867f969&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3867f969"]])

export default __exports__